import { SlidesLambdaFetch, awaitJSON } from "../../utils/fetch-utils";

export const fetchSummarySlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getSummaryData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      dimension: "channel",
      dateDimension: "date",
      retailer: retailer === "null" ? null : retailer,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchCampaignSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  sort: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getCampaignData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
      sort,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchKeywordSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  sort: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getKeywordData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
      sort,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchProductSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  sort: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getProductData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
      sort,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchDspSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getDspData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchBiggestMoverSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  filterField: string,
  dollarMin: number,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getBiggestMoversData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
      filterField,
      dollarMin,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchSeasonalitySlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getSeasonalityData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchFreeFormSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  sort: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getFreeFormData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchCategorySlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  sort: string,
  profileNames: string[]
): Promise<any> => {
  const res = await SlidesLambdaFetch("/getCategoryData", {
    method: "POST",
    body: {
      companyId,
      profileNames,
      startDate,
      endDate,
      retailer: retailer === "null" ? null : retailer,
      sort,
    },
  });
  const json = await awaitJSON(res);
  return json;
};

export const fetchBetterTogetherSlideData = async (
  companyId: string,
  startDate: string,
  endDate: string,
  retailer: string,
  profileNames: string[]
): Promise<any> => {
  // const { data } = await tmrClient.query({
  //   query: GET_DSP_SLIDE_DATA,
  //   variables: {
  //     companyId: "meyer",
  //     dateRange: { startDate, endDate },
  //     retailer: retailer === "null" ? null : retailer,
  //   },
  // });

  const data = await {
    tmr: {
      betterTogether: {
        dataByWeek: [
          {
            reportWeek: "sep 10 2023",
            searchSpend: 1918.34,
            searchSales: 802.92,
            searchRoas: 7.72,
            dspSpend: 0,
            dspSales: 0,
            dspRoas: null,
            totalAdSpend: 31918.34,
            totalAdSales: 108.92,
            totalAdRoas: 7.72,
            totalAdRevenue: 75,
            orderedRevenue: 0,
            shippedCogs: 0,
          },
          {
            reportWeek: "sep 17 2023",
            searchSpend: 918.34,
            searchSales: 14802.92,
            searchRoas: 7.72,
            dspSpend: 0,
            dspSales: 0,
            dspRoas: null,
            totalAdSpend: 1918.34,
            totalAdSales: 1408.92,
            totalAdRoas: 7.72,
            totalAdRevenue: 30,
            orderedRevenue: 0,
            shippedCogs: 0,
          },
          {
            reportWeek: "sep 24 2023",
            searchSpend: 5918.34,
            searchSales: 9802.92,
            searchRoas: 7.72,
            dspSpend: 0,
            dspSales: 0,
            dspRoas: null,
            totalAdSpend: 143918.34,
            totalAdSales: 12408.92,
            totalAdRoas: 7.72,
            totalAdRevenue: 92,
            orderedRevenue: 0,
            shippedCogs: 0,
          },
        ],
        summary: {
          totalAdSales: 14800,
          totalAdSalesChange: 50.6,
          totalAdSpend: 1920,
          totalAdSpendChange: 64.2,
          totalAdRoas: 7.72,
          totalAdRoasChange: 37.9,
          orderedRevenue: 0,
          orderedRevenueChange: "N/A",
          shippedCogs: 0,
          shippedCogsChange: "N/A",
          totalAdRevenue: 65,
          totalAdRevenueChange: -99.9,
          totalAdImpressions: 1700000,
          totalAdImpressionsChange: -50.1,
          totalAdDpv: 356,
          totalAdDpvChange: 42.8,
          totalAdClicks: 7200,
          totalAdClicksChange: -47.3,
        },
      },
    },
  };
  return data.tmr.betterTogether;
};
